/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Downloadlinksqralt3Inputs */

const en_downloadlinksqralt3 = /** @type {(inputs: Downloadlinksqralt3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QR code for ${i?.name}`)
};

const de_downloadlinksqralt3 = /** @type {(inputs: Downloadlinksqralt3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QR-Code für ${i?.name}`)
};

/**
* | output |
* | --- |
* | "QR code for {name}" |
*
* @param {Downloadlinksqralt3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksqralt3 = /** @type {((inputs: Downloadlinksqralt3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksqralt3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksqralt3(inputs)
	return de_downloadlinksqralt3(inputs)
});
export { downloadlinksqralt3 as "downloadLinksQrAlt" }